"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryCheckout = BasisTheoryCheckout;
var _react = _interopRequireDefault(require("react"));
var _StoredCardsCheckout = require("./StoredCardsCheckout");
/**
 * BasisTheoryCheckout component.
 *
 * Delegate stored- and new-card rendering and submission to StoredCardsCheckout.
 *
 * @param {object} props - Component props.
 * @param {boolean} props.active - Whether Basis Theory currently owns card submission.
 * @param {boolean} props.cardErrorOccured - Whether the card payment reported an error.
 * @param {string} props.publicKey - Basis Theory public API key.
 * @returns {React.ReactElement} Basis Theory checkout form.
 */
function BasisTheoryCheckout(_ref) {
  var _ref$active = _ref.active,
    active = _ref$active === void 0 ? true : _ref$active,
    _ref$cardErrorOccured = _ref.cardErrorOccured,
    cardErrorOccured = _ref$cardErrorOccured === void 0 ? false : _ref$cardErrorOccured,
    publicKey = _ref.publicKey;
  return /*#__PURE__*/_react["default"].createElement(_StoredCardsCheckout.StoredCardsCheckout, {
    active: active,
    cardErrorOccured: cardErrorOccured,
    publicKey: publicKey,
    "data-sentry-element": "StoredCardsCheckout",
    "data-sentry-component": "BasisTheoryCheckout",
    "data-sentry-source-file": "BasisTheoryCheckout.tsx"
  });
}